import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";

import { ShaDowBox } from "../../../../components/boxes";
import { getData } from "../../../../services";
import { GraphFooter, Progresses, allBuildingsItems } from "../../../../components/parts";
import { COLORS } from "../../../../theme/colors";
import { NoDataCard } from "../../../../components/parts";

export const RiskProfile = () => {
  const title = "Building's Risk Profile";
  const [points, setPoints] = useState([]);
  const [portfolioRisk, setPortfolioRisk] = useState();
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);

  useEffect(() => {
    getData(`/praas/v1/buildings/risk/`, (data) => {
      if (data) {
        setPortfolioRisk(data.portfolio);
        const rawPoints = [];

        if (data.industry) {
          let industryRisk = data.industry;
          rawPoints.push({
            left: industryRisk,
            type: "industry",
          });
        }
        setPoints(rawPoints);
      }
    });

    return () => {
      setPoints([]);
    };
  }, [cluster, segments, selectedCountries]);

  return (
    <ShaDowBox style={{ marginTop: 28 }}>
      {points?.length ? (
        <Box style={{ padding: 24 }}>
          <Typography variant="h4">{title}</Typography>
          <Box style={{ marginTop: 20 }}>
            <Progresses
              steps={[0, 2, 4]}
              progressBoxStyle={{
                minHeight: 160,
              }}
              mainPointLeft={portfolioRisk}
              insideStyle={{ backgroundColor: COLORS.gray[2] }}
              points={points}
            />
          </Box>
          <GraphFooter items={allBuildingsItems} />
        </Box>
      ) : (
        <NoDataCard
          withShaDowBox={false}
          boxStyle={{ paddingBottom: 46 }}
          title={title}
          footerNames={["Avg. portfolio", "Avg. Industry"]}
        />
      )}
    </ShaDowBox>
  );
};
